import React from 'react';
import { Root } from './styled.js';

const Body = ({ children }) => {
    return React.createElement(Root, { className: 'tend-ui-drawer-body' }, children);
};
Body.displayName = 'Drawer.Body';

export { Body };
